var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fcc-botoes-navegacao',{attrs:{"right":"","rightDisabled":_vm.buttonDisabled},on:{"proximo":function($event){return _vm.$emit('proximo')}}}),_c('fcc-table',{attrs:{"striped":"","hover":"","responsive":"","pagination":"","items":_vm.lista,"fields":_vm.fields},on:{"row-selected":_vm.selecionaItens}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }